import { CalendarX2 } from 'lucide-react';
import { SectionCardHeader } from '../../app/section-card-header.js';
import type { Appointment } from '../../lib/api.js';

const SOURCE = {
  COMPANY: 'Regra da empresa',
  UNIT: 'Regra da unidade',
  SERVICE: 'Regra do serviço',
} as const;

/// A regra de cancelamento e remarcação em vigor quando o agendamento foi feito (ADR 0071,
/// decisão 6). Mudar a configuração depois não altera este retrato. Agendamento anterior à
/// política não tem retrato e segue a devolução integral.
export function AppointmentCancellationPolicyCard({ appointment }: { appointment: Appointment }) {
  const snapshot = appointment.cancellationPolicy;
  if (!snapshot) return null;
  return (
    <div className="rounded-2xl border border-surface-border bg-surface-card shadow-soft">
      <SectionCardHeader title="Política de cancelamento" icon={CalendarX2} />
      <div className="grid gap-2 p-4 text-sm">
        <p className="text-xs text-content-muted">
          {SOURCE[snapshot.source]}, em vigor quando o agendamento foi feito.
        </p>
        <p className="leading-6">{snapshot.summary}</p>
      </div>
    </div>
  );
}
